<template>
  <div class="breadcrumb-area pos-relative w-100">
    <h1>{{ title }}</h1>
    <div class="float-right btn-group">
      <router-link class="font-medium f12 btn btn-outline-secondary" :to="backUrl"
        ><i class="bx bx-left-arrow-alt"></i>Quay lại</router-link
      >
    </div>
  </div>
</template>

<script>
  export default {
    props: ['title', 'backUrl'],
  }
</script>
